import { render, staticRenderFns } from "./carre_legende.vue?vue&type=template&id=18b7f74a"
import script from "./carre_legende.js?vue&type=script&lang=js&external"
export * from "./carre_legende.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports